import React from "react";
import { Loader2 } from "lucide-react";

export default function Spinner({ label = "Loading…", testId = "spinner" }) {
  return (
    <div
      data-testid={testId}
      className="flex items-center justify-center gap-2 py-8 text-slate-500"
    >
      <Loader2 size={16} className="animate-spin" />
      <span className="text-[12px]">{label}</span>
    </div>
  );
}
